<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'site',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>